import { PUSH_SRC_TYPE } from '../common/Enumerations';
import { StateConfig } from '../common/InternalTypes';
import { LoggerTexts } from '../common/LoggerTexts';
import { UserState } from '../data/UserState';
import { StorageService } from '../storage/StorageService';

export class Balancer {
	_storage: StorageService;

	init(storage: StorageService) {
		if (!storage) {
			throw new Error(LoggerTexts.BALANCER.CTOR_STORAGE_NOT_PROVIDED);
		}
		this._storage = storage;
	}

	balance(pushSourceType: PUSH_SRC_TYPE, stateConfig?: StateConfig): boolean {
		return this._isSurveyTimeFrameReached(pushSourceType, stateConfig);
	}

	_isSurveyTimeFrameReached(pushSourceType: PUSH_SRC_TYPE, stateConfig?: StateConfig): boolean {
		const userState = this._readUserState();
		let pushDate = 0;
		if (userState) {
			if (pushSourceType === PUSH_SRC_TYPE.timed) {
				pushDate = userState.timedPushDate;
			} else if (pushSourceType === PUSH_SRC_TYPE.appPush) {
				pushDate = userState.appPushDate;
			} else if (pushSourceType === PUSH_SRC_TYPE.instantPush) {
				pushDate = this._getInstantPushConfigStateNextPushDate(userState, stateConfig);
			} else {
				pushDate = Date.now() + 850301;
			}
		} else {
			pushDate = Date.now() + 850301;
		}
		return pushDate <= Date.now();
	}

	_readUserState(): UserState | undefined {
		return this._storage.readUserState();
	}

	private _getInstantPushConfigStateNextPushDate(userState: UserState, stateConfig?: StateConfig) {
		if (!stateConfig) {
			return Date.now() + 850301;
		}
		const currentInstantPushConfigState = userState.getInstantPushConfigState(stateConfig.state.areaId, stateConfig.state.triggerName);
		if (currentInstantPushConfigState) {
			return currentInstantPushConfigState.nextPushDateTime;
		}
		return Date.now() + 850301;
	}
}
